import { render } from "./WelcomeAnimation.vue?vue&type=template&id=4da2fe2e&scoped=true&ts=true"
import script from "./WelcomeAnimation.vue?vue&type=script&lang=ts"
export * from "./WelcomeAnimation.vue?vue&type=script&lang=ts"

import "./WelcomeAnimation.vue?vue&type=style&index=0&id=4da2fe2e&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da2fe2e"]])

export default __exports__